module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "PayByQrCodeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PayByQrCodeView!./src/pages/Shop/PayMent/PayByQRcode/index.js
// module id = 1376
// module chunks = 418